var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.824,
    height: 15.824,
    viewBox: "0 0 15.824 15.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.483,1.928c-4.37,0-7.912,1.107-7.912,2.473V5.884L8.5,11.818v4.945c0,.546.886.989,1.978.989s1.978-.443,1.978-.989V11.818L18.4,5.884V4.4C18.4,3.035,14.853,1.928,10.483,1.928ZM4.029,4.073a6.73,6.73,0,0,1,1.5-.579,19.506,19.506,0,0,1,4.95-.577,19.506,19.506,0,0,1,4.95.577,6.731,6.731,0,0,1,1.5.579,1.72,1.72,0,0,1,.437.327,1.722,1.722,0,0,1-.437.327,6.731,6.731,0,0,1-1.5.579,19.506,19.506,0,0,1-4.95.577,19.506,19.506,0,0,1-4.95-.577,6.73,6.73,0,0,1-1.5-.579A1.722,1.722,0,0,1,3.592,4.4,1.722,1.722,0,0,1,4.029,4.073Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fd6c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOrange);
export default __webpack_public_path__ + "static/media/filter_orange.89ce2c860ab3999ce2a48992eaea0355.svg";
export { ForwardRef as ReactComponent };